import apple from '../imgs/ic_apple.svg';
import appleSelect from '../imgs/ic_apple_select.svg';
import credit from '../imgs/ic_credit.svg';
import creditSelect from '../imgs/ic_credit_select.svg';
import hana from '../imgs/ic_hana.svg';
import hanaSelect from '../imgs/ic_hana_select.svg';
import kakao from '../imgs/ic_kakao.svg';
import kakaoSelect from '../imgs/ic_kakao_select.svg';
import kb from '../imgs/ic_kb.svg';
import kbSelect from '../imgs/ic_kb_select.svg';
import payco from '../imgs/ic_payco.svg';
import paycoSelect from '../imgs/ic_payco_select.svg';
import phone from '../imgs/ic_phone.svg';
import phoneSelect from '../imgs/ic_phone_select.svg';
import prepay from '../imgs/ic_prepay.svg';
import prepaySelect from '../imgs/ic_prepay_select.svg';
import sol from '../imgs/ic_sol.svg';
import solSelect from '../imgs/ic_sol_select.svg';
import woori from '../imgs/ic_woori.svg';
import wooriSelect from '../imgs/ic_woori_select.svg';

const methodList = [
  {
    children: '신용카드', icon: credit, selectIcon: creditSelect, method: 'CREDIT_CARD',
  },
  {
    children: '카카오페이', icon: kakao, selectIcon: kakaoSelect, method: 'KAKAO_PAY',
  },
  {
    children: '페이코', icon: payco, selectIcon: paycoSelect, method: 'PAYCO',
  },
  {
    children: '애플페이', icon: apple, selectIcon: appleSelect, method: 'APPLE_PAY',
  },
] as const;

export default methodList;
